import React from 'react';
import { ShieldCheck, Eye, Wallet, AlertTriangle } from 'lucide-react';

const tips = [
  {
    icon: ShieldCheck,
    title: 'Use a Secure Wallet',
    description: 'Store your Bitcoin in a reputable hardware or software wallet. Never share your private keys.'
  },
  {
    icon: Eye,
    title: 'Verify Transactions',
    description: 'Always double-check wallet addresses and transaction details before confirming.'
  },
  {
    icon: Wallet,
    title: 'Backup Your Wallet',
    description: 'Keep secure backups of your wallet recovery phrases in a safe location.'
  },
  {
    icon: AlertTriangle,
    title: 'Be Cautious',
    description: 'Be wary of scams and only use verified BTM locations for transactions.'
  }
];

export default function SecurityTips() {
  return (
    <section className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h2 className="text-3xl font-bold text-white mb-6">Security Tips</h2>
      <p className="text-gray-300 mb-8">
        Protecting your Bitcoin investment is crucial. Follow these essential security practices 
        to keep your digital assets safe.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {tips.map((tip, index) => (
          <div key={index} className="flex items-start space-x-4 p-6 bg-gray-700/50 rounded-lg">
            <tip.icon className="w-8 h-8 text-purple-500 flex-shrink-0" />
            <div>
              <h3 className="text-xl font-semibold text-white mb-2">{tip.title}</h3>
              <p className="text-gray-400">{tip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}